import loadingStyle from "./loading.module.css"


export default function Loading(props) {

    const loading = props['loading']

    return(
        <div
            className={loadingStyle.spinner_container}
            style={{
                display: loading ? "flex" : "none"
            }}
        >
            <div className={loadingStyle.spinner}></div>
        </div>
    )
}